import React, { useContext, useState } from "react"
import { AccesibilidadContext, TemasDisponibles } from "../../contexts/AccesibilidadContext"
import { Img } from "../shared/img"
import PropTypes from 'prop-types';
import useObtenerSubsecciones from "../../js/translations/useObtenerSubsecciones";

/**
 * Componente generico para mostrar items del menú de búsqueda avanzada el cual muestra una imagen, el titulo, y recibe un parametro onClick.
 * @returns {React.Component}
 */
 const ItemCard = ({ imgPath, name, onClick }) => {
    const {textosSubSecciones:textos} = useObtenerSubsecciones('busqueda_avanzada');

    return <button className="focusable-red item-card d-flex  align-items-center" onClick={() => onClick && onClick()} aria-label={`${textos?.a11y?.ItemCard?.aria || "Buscar por"} ${name}`}>
        <div className="item-card-image">
            <Img  src={imgPath} alt="" aria-hidden={true} className="img-fluid"/>
        </div>
        
        <p>{name}</p>
    </button>
}
ItemCard.propTypes = {
    /**
     * Ruta de la imagen que se va a renderizar.
     */
    imgPath:PropTypes.string,
    /**
     * Nombre del item (se mostrará como título del item)
     */
    name:PropTypes.string,
    /**
     * Función que se ejecuta cuando se hace click en el componente.
     */
    onClick:PropTypes.func,
}

/**
 * Componente generico para mostrar items del menú de búsqueda avanzada el cual muestra una imagen, el titulo, y recibe un parametro onClick.
 * @returns {React.Component}
 */
const DefaultItemCard = ({ imgPath, name, onClick }) => {
    return <button className="focusable-secondary default-item-card d-flex flex-column align-items-center" onClick={() => onClick && onClick()}>
        <Img className="item-card-image" src={imgPath} alt={`genre-${name}`} />
        <p>{name}</p>
    </button>
}

DefaultItemCard.propTypes = {
    /**
     * Ruta de la imagen que se va a renderizar.
     */
    imgPath:PropTypes.string,
    /**
     * Nombre del item (se mostrará como título del item)
     */
    name:PropTypes.string,
    /**
     * Función que se ejecuta cuando se hace click en el componente.
     */
    onClick:PropTypes.func,
}

/**
 * Componente  para mostrar niveles de lectura  en el menú de búsqueda avanzada el cual muestra una imagen, el titulo, y recibe un parametro onClick.
 * @returns {React.Component}
 */
const ReadingLevelCard = ({ imgClass, name, onClick }) => {
    return (
        <button
            className={`focusable-red reading-level-card d-flex justify-content-end align-items-center ${imgClass}`}
            onClick={() => onClick && onClick()}
        >
            <div className="name">
                <p>{name}</p>
            </div>
        </button>
    )
}
ReadingLevelCard.propTypes = {
    /**
     * Ruta de la imagen que se va a renderizar.
     */
    imgPath:PropTypes.string,
    /**
     * Nombre del item (se mostrará como título del item)
     */
    name:PropTypes.string,
    /**
     * Función que se ejecuta cuando se hace click en el componente.
     */
    onClick:PropTypes.func,
}

const ReadingLists = ({onClick, name, icon, iconClass}) => {
    const { textosSubSecciones: textos } = useObtenerSubsecciones('busqueda_avanzada');
    const Icon = icon;
    return (
        <button 
            className="focusable-red item-reading-list d-flex  align-items-center" 
            onClick={() => onClick && onClick()} 
            aria-label={`${textos?.a11y?.ItemCard?.aria || "Buscar por"} ${name}`}
        >
            <Icon className={`icon-reading-list ${iconClass}`} width={48}/>
            <p>{name}</p>
        </button>
    )
}

export const AdvancedSearchItems = {
    DefaultItemCard,
    ItemCard,
    ReadingLevelCard,
    ReadingLists
}


